// to avoid external iframes, like youtube embeds and rebel mouse social media feeds from holding up window.load firing, remove iframe src, then add them back after window.load has fired
// http://stackoverflow.com/a/14761375/781350
(function($){
    //DOM is ready
    $(document).ready(function(){
        var frame = $('iframe');
        var frameSrc = new Array();

        if( frame.length ){
            $.each( frame, function(i, f){
                frameSrc[i] = $(f).attr('src');
                //remove the src attribute so window will ignore these iframes
                $(f).attr('src', '');
            });

            //window finish load
            $(window).on('load',function(){
                $.each( frame, function(a, x){
                    //put the src attribute value back
                    $(x).attr('src', frameSrc[a]);
                });
            });
        }
    });
})(jQuery);

$(window).on('load', function(){

	var root = $('#application_root').text();
	var crossFade = true;

	$('body').bind('checkImgWidth', function(e){
		checkImgWidths();
	});

	function checkImgWidths(){
		
		if ($('#mainArea')[0]) {
			
			var images = $('img', '#mainArea');
			
		} else { // Fallback for old container ID. Added 2018-10-23. - CKS
			
			var images = $('img', '#container'); // this is inside the checkImgWidths function instead of in window.load because some images may have been dynamically added to the page after load, so I want those images to also be included for up-sizing
			
		}
		
		var pxDensity = 1.0;
		
		if (window.devicePixelRatio) {
			pxDensity = parseFloat(window.devicePixelRatio);
		}
		
		images.each(function(){
			
			var img = $(this);
			
			if (img.closest('.directory-list').size() === 0 && img.attr('src').toLowerCase().indexOf('photomanager') > -1 || img.attr('src').toLowerCase().indexOf('e-net/getimage')) {
				var elementWidth = parseInt(img.width());
				
				var currentSrcWidth = parseInt(getQueryVariable(img.attr('src'), 'w'));
				
				// we decided to hardcode quality=80 at the server level to avoid some edge cases where small images got stuck with q=50
				//var currentSrcQuality = parseInt(getQueryVariable(img.attr('src'), 'q'));
				
				//img.attr('src', img.attr('src').replace('q=' + currentSrcQuality, 'q=80'));
				
				if (elementWidth > parseInt(currentSrcWidth / pxDensity)) { // only change image size if the image is getting larger, otherwise css will just scale down
					
					var newSrc = img.attr('src').replace('w=' + currentSrcWidth, 'w=' + parseInt(elementWidth * pxDensity));
					//newSrc = newSrc.replace('q=' + currentSrcQuality, 'q=80');
					
					var newImage = new Image();
					
					newImage.onload = function(){
						
						if (crossFade == true) {
							if (img.next().is('.img_cover_load')) {
								img.next().remove();
							}
						
							var existingImgClass = ''; img.attr('class');
						
							if (img.attr('class') != undefined) {
								existingImgClass = $.trim(img.attr('class').replace('img_cover_load','').replace('photo','')); // remove the photo class because it adds an extra box shadow that isn't needed
							}
						
							var cover = $('<img src="' + newSrc + '" class="img_cover_load ' + existingImgClass + '" />');
						
							var imgOffset = img.position();
						
							cover.css('left', imgOffset.left);
							cover.css('top', imgOffset.top);
						
							var originalStyles = img.getStyleObject();
							cover.css(originalStyles);
						
							cover.css('position', 'absolute');
						
							if (cover.css('top') == 'auto') {
								cover.css('top', imgOffset.top);
							}
						
							if (cover.css('left') == 'auto') {
								cover.css('left', imgOffset.left);
							}
						
							cover.width(img.width());
							cover.height(img.height());
						
							cover.css('opacity', 0.0);
						
							img.after(cover);
						
							cover.animate({opacity: 1.0}, 500, function(){
								img.attr('src', newSrc);
							
								setTimeout(function(){
									cover.animate({opacity: 0.0}, 150, function(){
										cover.remove();
									});
								}, 50);
							
							});
						} else { // it's not a cross fade
							img.attr('src', newSrc);
						}
						
					};
					
					newImage.src = newSrc;
				}
		
			}
		});
	}
	
	// http://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-or-resize-event-and-only-then-perform-an-ac
	var resizeTimer;
	
	$(window).resize(function(){
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(checkImgWidths, 100);
	});
	
	checkImgWidths();
	
	function getQueryVariable(url, variable) {
		if (url.split('?')[1] == undefined) {
			return (false);
		}
		
		var query = url.split('?')[1].replace(/&amp;/g,'&'); 
		var vars = query.split('&');
	
		for (var i=0;i<vars.length;i++) {
			var pair = vars[i].split("=");
			if(pair[0] == variable){return pair[1];}
		}
		return(false);
	}
});

/*
 * http://stackoverflow.com/questions/754607/can-jquery-get-all-css-styles-associated-with-an-element
 * getStyleObject Plugin for jQuery JavaScript Library
 * From: http://upshots.org/?p=112
 */

(function($){
	
	var importantStyles = ['z-index','margin-left', 'margin-right', 'margin-bottom', 'margin-top', 'padding-left', 'padding-right', 'padding-top', 'padding-bottom', 'left', 'top', 'bottom', 'right','border','border-left','border-right','border-top','border-bottom','border-bottom-width','border-top-width','border-left-width','border-right-width','border-bottom-style','border-top-style','border-left-style','border-right-style','border-bottom-color','border-top-color','border-left-color','border-right-color','box-sizing','align-items'];
	
    $.fn.getStyleObject = function(){
        var dom = this.get(0);
        var style;
        var returns = {};
        if(window.getComputedStyle){
            var camelize = function(a,b){
                return b.toUpperCase();
            };
            style = window.getComputedStyle(dom, null);
            for(var i = 0, l = style.length; i < l; i++){
                var prop = style[i];
                
                if (importantStyles.indexOf(prop) > -1) {                
					var camel = prop.replace(/\-([a-z])/g, camelize);
					var val = style.getPropertyValue(prop);
					returns[camel] = val;
                }
            };
            return returns;
        };
        if(style = dom.currentStyle){
            for(var prop in style){
                returns[prop] = style[prop];
            };
            return returns;
        };
        return this.css();
    }
})(jQuery);